import React, { useState, useEffect } from "react";
import axios from "axios";
import { Container, Button, Spinner, Alert } from "react-bootstrap";

const CertificateDownload = ({ userId }) => {
  const [recycledCount, setRecycledCount] = useState(0);
  const [eligible, setEligible] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchRecycledData = async () => {
      try {
        const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8080";
        const response = await axios.get(`${API_URL}/ewaste/user/${userId}`);
        const totalRecycled = response.data
          .filter(item => item.status === "RECYCLED")
          .reduce((sum, item) => sum + item.quantity, 0);

        setRecycledCount(totalRecycled);
        setEligible(totalRecycled >= 100);
      } catch (err) {
        setError("Failed to fetch recycled count.");
        console.error("Error fetching recycled count:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchRecycledData();
  }, [userId]);

  const downloadCertificate = async () => {
    const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8080";
    try {
      const response = await axios.get(`${API_URL}/certificate/download/${userId}`, {
        responseType: "blob",
      });

      const blob = new Blob([response.data], { type: "application/pdf" });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "Recycling-Certificate.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(link.href); // Clean up
    } catch (err) {
      console.error("Error downloading certificate:", err);
      setError("Failed to download certificate.");
    }
  };

  return (
    <Container className="text-center mt-4 p-4 glass-card border-white-10">
      <h4 className="text-white mb-4">Total Recycled: {loading ? <Spinner animation="border" size="sm" variant="primary" /> : <span className="text-primary fw-bold">{recycledCount}</span>} Units</h4>

      {error && <Alert variant="danger" className="glass-card border-danger text-white">{error}</Alert>}

      {eligible ? (
        <Button className="btn-premium px-5 py-2" onClick={downloadCertificate}>
          Download Your Certificate
        </Button>
      ) : (
        <div className="text-white-50 small">Recycle at least <span className="text-white fw-bold">100 units</span> to earn an official certificate!</div>
      )}
    </Container>
  );
};

export default CertificateDownload;
